import React from "react";
import { Row, Col } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { HookFormInputGroup, HookFormRadioButton } from "components";
import { useBackendPlatform } from "hooks";
import { trimMidSentenceNormalizer, trimNormalizer } from "validators";
import {
	maxLength50,
	minLength8,
	normalizeAll,
	noSpace,
	onlyAlphanumericAndSpecialCharacters,
	validSubdomain,
} from "validators/validation";

type RiseOsSectionProps = {
	sectionName: string;
	isLoading: boolean;
	isApplication?: boolean;
};

const RiseOsSection = ({
	sectionName,
	isLoading = false,
	isApplication = false,
}: RiseOsSectionProps) => {
	const {
		register,
		watch,

		formState: { errors },
	} = useFormContext();
	const backEndPlatform = watch("backEndPlatform");
	const { isBackEndPlatformOmaha } = useBackendPlatform(backEndPlatform);
	const omahaFrontEndPlatform = watch("omahaFrontEndPlatform");

	return (
		<>
			{!isApplication && (
				<>
					<Row className="form-group" data-autotest="riseOsSection">
						<Col md={5}>
							<HookFormInputGroup
								name={`${sectionName}.subdomain`}
								register={register}
								label="Subdomain"
								colInput={6}
								colLabel={6}
								blurLoading={isLoading}
								autoComplete="off"
								validator={{
									maxLength50,
								}}
								normalize={normalizeAll([
									validSubdomain,
									trimMidSentenceNormalizer,
									noSpace,
								])}
								normalizeOnBlur={trimNormalizer}
								errors={errors}
							/>
						</Col>
						<Col md={{ span: 5, offset: 2 }}>
							<HookFormInputGroup
								name={`${sectionName}.username`}
								register={register}
								label="Username"
								colInput={6}
								colLabel={6}
								blurLoading={isLoading}
								autoComplete="off"
								validator={{
									maxLength50,
								}}
								normalize={normalizeAll([
									onlyAlphanumericAndSpecialCharacters,
									trimMidSentenceNormalizer,
									noSpace,
								])}
								normalizeOnBlur={trimNormalizer}
								errors={errors}
							/>
						</Col>
					</Row>
					<Row className="form-group">
						<Col md={5}>
							<HookFormInputGroup
								name={`${sectionName}.displayName`}
								register={register}
								label="Display Name"
								colInput={6}
								colLabel={6}
								blurLoading={isLoading}
								autoComplete="off"
								validator={{
									maxLength50,
								}}
								normalize={normalizeAll([
									onlyAlphanumericAndSpecialCharacters,
									trimMidSentenceNormalizer,
								])}
								normalizeOnBlur={trimNormalizer}
								errors={errors}
							/>
						</Col>
						{isBackEndPlatformOmaha && omahaFrontEndPlatform && (
							<Col md={{ span: 5, offset: 2 }}>
								<HookFormInputGroup
									name={`${sectionName}.hostPassword`}
									register={register}
									label="Host Password"
									colInput={6}
									colLabel={6}
									blurLoading={isLoading}
									autoComplete="off"
									validator={{
										minLength8,
										maxLength50,
									}}
									type="password"
									normalize={normalizeAll([
										onlyAlphanumericAndSpecialCharacters,
										trimMidSentenceNormalizer,
										noSpace,
									])}
									normalizeOnBlur={trimNormalizer}
									errors={errors}
								/>
							</Col>
						)}
					</Row>
				</>
			)}
			<p>Level 2 &amp; 3 data</p>
			<Row className="form-group">
				<Col md={2}>
					<HookFormRadioButton
						id={`${sectionName}.isLevel2And3DataEnabledYes`}
						name={`${sectionName}.isLevel2And3DataEnabled`}
						register={register}
						value="true"
						label="Yes"
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={2}>
					<HookFormRadioButton
						id={`${sectionName}.isLevel2And3DataEnabledNo`}
						name={`${sectionName}.isLevel2And3DataEnabled`}
						register={register}
						value="false"
						label="No"
						blurLoading={isLoading}
					/>
				</Col>
			</Row>
			<p>Cash Discount</p>
			<Row className="form-group">
				<Col md={2}>
					<HookFormRadioButton
						id={`${sectionName}.isCashDiscountEnabledYes`}
						name={`${sectionName}.isCashDiscountEnabled`}
						register={register}
						value="true"
						label="Yes"
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={2}>
					<HookFormRadioButton
						id={`${sectionName}.isCashDiscountEnabledNo`}
						name={`${sectionName}.isCashDiscountEnabled`}
						register={register}
						value="false"
						label="No"
						blurLoading={isLoading}
					/>
				</Col>
			</Row>
		</>
	);
};

export default RiseOsSection;
